<h3>Editing Blog</h3>

<mat-form-field class="example-full-width" appearance="fill" style="width:50%;margin-bottom: 5%;">
    <mat-label>Tittle</mat-label>
    <input type="text" matInput [formControl]="tittleFormControl" placeholder="Bus registration">
    <mat-hint>Tittle length should be 3 to 60</mat-hint>
    <mat-error *ngIf="tittleFormControl.hasError('required')">
        Tittle is <strong>required</strong>
    </mat-error>
</mat-form-field>
<br>
<mat-form-field class="example-full-width" appearance="fill" style="width:70%;margin-bottom: 5%;">
    <mat-label>SubTittle</mat-label>
    <input type="text" matInput [formControl]="subTittleFormControl" placeholder="Registration of the bus">
    <mat-hint>Subtittle length should be 5 to 70</mat-hint>
    <mat-error *ngIf="subTittleFormControl.hasError('required')">
        SubTittle is <strong>required</strong>
    </mat-error>
</mat-form-field>
<br>
<mat-form-field class="example-full-width" appearance="fill" style="width:40%;margin-bottom: 5%;">
    <mat-label>Author</mat-label>
    <input type="text" matInput [formControl]="authorFormControl" placeholder="Bus Dept">
    <mat-hint>Auth ex. Mr Shezi,Mr Quma</mat-hint>
    <mat-error *ngIf="authorFormControl.hasError('required')">
        Author is <strong>required</strong>
    </mat-error>
</mat-form-field>
<br>
<mat-form-field class="example-full-width" appearance="fill" style="width:80%;margin-bottom: 5%;">
    <mat-label>Discription</mat-label>
    <textarea matInput [formControl]="discriptionFormControl" style="height:190px;"></textarea>
    <mat-hint>Discription length should be 5 to 600</mat-hint>
    <mat-error *ngIf="discriptionFormControl.hasError('required')">
        Discription is <strong>required</strong>
    </mat-error>
</mat-form-field>
<br>
<mat-form-field class="example-full-width" appearance="fill" style="width:100%;margin-bottom: 5%;">
    <mat-label>link</mat-label>
    <input type="text" matInput [formControl]="linkFormControl" placeholder="https//amazon.com">
    <mat-hint>https://google.com</mat-hint>
    <mat-error *ngIf="linkFormControl.hasError('required')">
        Link is <strong>required</strong>
    </mat-error>
</mat-form-field>

<button mat-stroked-button (click)="save()">Save</button>
<button mat-stroked-button style="margin-left: 80%;" (click)="onNoClick()">Close</button>